'use client'

import { useDialogPortalContainer } from '@/components/ui/dialog/DialogPortalContext'
import { Portal } from '@/components/utils/Portal'
import { ScrollContextProvider } from '@/components/utils/ScrollContext'
import { useForwardedRef } from '@/hooks/useForwardedRef'
import { cn } from '@/lib/utils'
import { ForwardedRef, ReactNode, forwardRef } from 'react'

export type FullScreenDialogProps = {
  open?: boolean
  portal?: boolean
  className?: string
  children?: ReactNode
}

export const FullScreenDialog = forwardRef(
  (
    { open, portal, className, children }: FullScreenDialogProps,
    forwardedRef: ForwardedRef<HTMLDialogElement>
  ) => {
    const dialogPortalContainer = useDialogPortalContainer()
    const dialogRef = useForwardedRef(forwardedRef)
    if (portal) {
      return (
        <Portal container={dialogPortalContainer}>
          <ScrollContextProvider scrollingElementRef={dialogRef}>
            <dialog
              ref={dialogRef}
              open={open}
              className={cn(
                'fixed inset-0 m-0 h-full w-full overflow-auto bg-transparent',
                className
              )}
            >
              {children}
            </dialog>
          </ScrollContextProvider>
        </Portal>
      )
    }
    return (
      <ScrollContextProvider scrollingElementRef={dialogRef}>
        <dialog
          ref={dialogRef}
          open={open}
          className={cn('fixed inset-0 m-0 h-full w-full overflow-auto bg-transparent', className)}
        >
          {children}
        </dialog>
      </ScrollContextProvider>
    )
  }
)
